import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';
import SingleService from '../../components/Service';

import shapeImg from '../../assets/img/service/shape-1-1.png';
import serviceImg1 from '../../assets/img/service/service-1-1.jpg';
import serviceImg2 from '../../assets/img/service/service-1-2.jpg';
import serviceImg3 from '../../assets/img/service/service-1-3.jpg';

const Service = () => {
  return (
    <div
      id="it-service"
      className="it-service-area p-relative z-index grey-bg pt-115 pb-90"
    >
      <div className="it-service-shape-1">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="it-service-title-wrap mb-75">
          <div className="row align-items-end">
            <div className="col-xl-6 col-lg-6 col-md-7">
              <SectionTitle
                itemClass="it-service-title-box"
                subTitleClass="it-section-subtitle"
                subTitle="خدماتنا"
                titleClass="it-section-title"
                title="الخدمات التي نقدمها."
              />
            </div>
            <div className="col-xl-6 col-lg-6 col-md-5">
              <div className="it-service-button text-md-start">
                <Link className="it-btn-theme mr-30" to="/service">
                  <Button btnText="عرض جميع الخدمات" />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleService
              categoryClass="it-service-category mb-30"
              category="الصحة العقلية"
              thumbClass="it-service-thumb mb-25"
              serviceImage={serviceImg1}
              contentClass="it-service-content"
              title="غذائية خدمات العلاج"
              description="الصحة والطب يشمل نطاقا واسعا مجموعة من المواضيع المتعلقة
                    بالصحة"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleService
              categoryClass="it-service-category mb-25"
              category="الصحة العقلية"
              thumbClass="it-service-thumb mb-5"
              serviceImage={serviceImg2}
              contentClass="it-service-content mb-25"
              title="تكاملي ممارسة الطب"
              description="الصحة والطب يشمل نطاقا واسعا مجموعة من المواضيع المتعلقة
                    بالصحة"
              isContentFirst
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleService
              categoryClass="it-service-category mb-30"
              category="الصحة العقلية"
              thumbClass="it-service-thumb mb-25"
              serviceImage={serviceImg3}
              contentClass="it-service-content"
              title="غذائية خدمات العلاج"
              description="الصحة والطب يشمل نطاقا واسعا مجموعة من المواضيع المتعلقة
                    بالصحة"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
